import { render, staticRenderFns } from "./FooterQuestions.vue?vue&type=template&id=72b51e06&"
import script from "./FooterQuestions.vue?vue&type=script&lang=js&"
export * from "./FooterQuestions.vue?vue&type=script&lang=js&"
import style0 from "./FooterQuestions.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports